import type {MapCursor} from '@gaia/utils/gaia/useInteractionHandlers';

export const editingFolder = {
    getCursor: (): MapCursor => 'default',
    onMouseDown: () => {},
    onMouseUp: () => {},
    onMouseMove: () => {},
    onMouseOut: () => {},
    onClick: () => {},
    onDblClick: () => {},
};
